import { statusTone, humanize } from '@/config/status';

export function StatusBadge({ status, dot = true }: { status: string; dot?: boolean }) {
  const tone = statusTone[status] ?? 'grey';
  return <span className={`status status--${tone}`}>{dot && <span className="status__dot" />}{humanize(status)}</span>;
}
